import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderDuplicateNameDialogComponent } from './work-order-duplicate-name-dialog.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CtButtonModule, CtFrameworkModule } from '@ctsolution/ct-framework';

/**
 * Modulo per il componente dialog di errore duplicato nome work order
 * Dialog bloccante che impedisce il salvataggio di work order con nomi duplicati
 */
@NgModule({
  declarations: [
    WorkOrderDuplicateNameDialogComponent
  ],
  imports: [
    CommonModule,
    CtButtonModule,
    MatLegacyDialogModule,
    MatIconModule,
    TranslateModule,
    CtFrameworkModule
  ],
  exports: [
    WorkOrderDuplicateNameDialogComponent
  ]
})
export class WorkOrderDuplicateNameDialogModule { }
